'use client';

import Image from 'next/image';
import { ActivatedPanel, SignedInFooter } from './activation-ui';

interface ActivationV2SuccessProps {
  firmName: string;
  userEmail: string;
  /** `trial` for a pending→trial firm; `subscription` for an active-free→active
   *  immediate conversion (LF-4535). */
  variant?: 'trial' | 'subscription';
}

/**
 * Temporary post-Stripe success screen for the v2 activation gate (LF-4535).
 *
 * Shown the moment the user returns from Stripe checkout, while the gate polls
 * the firm's `membershipStatus` for the backend webhook to flip it to `trial`
 * or `active`. Restores the confirmation the v1 gate gave: without it the v2
 * gate dropped the user straight onto the matters dashboard with no feedback
 * that activation had succeeded.
 */
export function ActivationV2Success({
  firmName,
  userEmail,
  variant = 'trial'
}: ActivationV2SuccessProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-6 py-12">
      <Image
        src="/ValeBlackLogo.svg"
        alt="Vale"
        width={40}
        height={40}
        priority
      />

      <div className="mt-8 w-full max-w-lg rounded-xl border border-gray-200 bg-white p-8 shadow-sm">
        <ActivatedPanel firmName={firmName} variant={variant} />
      </div>

      <SignedInFooter email={userEmail} className="mt-6" />
      <p className="mt-2 text-xs text-gray-400">&copy; Vale Innovations 2026</p>
    </div>
  );
}
